import { Container } from '../../ui'
import cn from 'classnames'

import { ReactComponent as ArrowIcon } from './assets/images/arrow.svg'
import { ReactComponent as TelegramIcon } from './assets/images/telegram.svg'
import { ReactComponent as WhatsappIcon } from './assets/images/whatsapp.svg'
import { ReactComponent as FacebookIcon } from './assets/images/facebook.svg'
import { ReactComponent as InstagramIcon } from './assets/images/instagram.svg'

import c from './assets/sass/messengers.module.scss'

const Messengers = () => {
    return (
        <Container>
            <div className={c.component}>
                <ul className={c.list}>
                    <li className={c.item}>
                        <a
                            href="https://t.me/dlmassage"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={c.link}
                        >
                            <div className={c.socialIcon}>
                                <TelegramIcon className={c.linkIcon} />
                            </div>
                            <div className={c.linkRow}>
                                <div className={c.linkTitle}>Telegram</div>
                                <div className={c.linkText}>
                                    Перейти
                                    <ArrowIcon className={c.arrowIcon} />
                                </div>
                            </div>
                        </a>
                    </li>
                    <li className={c.item}>
                        <a
                            href="https://www.facebook.com/dlmassag"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={c.link}
                        >
                            <div className={c.socialIcon}>
                                <FacebookIcon className={c.linkIcon} />
                            </div>
                            <div className={c.linkRow}>
                                <div className={c.linkTitle}>Facebook</div>
                                <div className={c.linkText}>
                                    Перейти
                                    <ArrowIcon className={c.arrowIcon} />
                                </div>
                            </div>
                        </a>
                    </li>
                    <li className={c.item}>
                        <a
                            href="https://www.instagram.com/dl_massage/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={c.link}
                        >
                            <div className={c.socialIcon}>
                                <InstagramIcon className={c.linkIcon} />
                            </div>
                            <div className={c.linkRow}>
                                <div className={c.linkTitle}>Instagram</div>
                                <div className={c.linkText}>
                                    Перейти
                                    <ArrowIcon className={c.arrowIcon} />
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <a
                    href="https://wa.me/wa.me/79856656294"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn(c.link, c.whatsapp)}
                >
                    <div className={c.socialIcon}>
                        <WhatsappIcon className={c.linkIcon} />
                    </div>
                    <div className={c.linkRow}>
                        <div className={c.linkTitle}>Whatsapp</div>
                        <div className={c.linkText}>
                            Связаться
                            <ArrowIcon className={c.arrowIcon} />
                        </div>
                    </div>
                </a>
            </div>
        </Container>
    )
}

export default Messengers
